var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveysEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "409px",
    height: "512px",
    viewBox: "0 0 409 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Art",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Survey",
    transform: "translate(-267.000000, -94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "surveys-empty",
    transform: "translate(267.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.71698113,33.4198473 C12.5605892,28.762737 18.9914068,26.2894546 27.009434,26 L385.849057,26 C391.161943,26.1617548 396.306597,28.6350372 401.283019,33.4198473 C405.309742,37.2915258 407.882069,42.2380906 409,48.259542 L409,489.740458 C407.882069,495.761909 405.309742,500.708474 401.283019,504.580153 C396.306597,509.364963 389.87578,511.838245 381.990566,512 L23.1509434,512 C16.8312342,511.506315 11.6865801,509.033032 7.71698113,504.580153 C3.96959893,500.376544 1.39727189,495.429979 0,489.740458 L0,51.9694656 C0.985117489,43.6024317 3.55744453,37.4192256 7.71698113,33.4198473 Z",
    id: "Rectangle",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FAFAFA",
    points: "38 63 366 63 366 389.740741 288.823529 464 38 464"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D8D8D8",
    points: "289 390 366 390 289 464"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(81.000000, 308.000000)",
    stroke: "#D8D8D8",
    strokeLinecap: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "61 0 24.3811728 52 0 31.4244604"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D8D8D8",
    strokeWidth: 6,
    x: 80,
    y: 230,
    width: 55,
    height: 53
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(158.000000, 234.000000)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 0,
    y: 0,
    width: 174,
    height: 7.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 0,
    y: 29.6,
    width: 104.4,
    height: 7.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 119.866667,
    y: 29.6,
    width: 54.1333333,
    height: 7.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(158.000000, 319.000000)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 0,
    y: 29.6,
    width: 112.133333,
    height: 7.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 127.6,
    y: 29.6,
    width: 46.4,
    height: 7.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 0,
    y: 0,
    width: 174,
    height: 7.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(158.000000, 152.000000)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 25.6666667,
    width: 54.1333333,
    height: 7.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 69.6,
    y: 25.6666667,
    width: 104.4,
    height: 7.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 174,
    height: 7.33333333
  })), /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(81.000000, 137.000000)",
    stroke: "#D8D8D8",
    strokeLinecap: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "61 0 24.3811728 52 0 31.4244604"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D8D8D8",
    points: "127.863636 44.3076923 137.931252 32.9075766 185.818182 3.69230769 197.409091 0 220.590909 0 232.181818 3.69230769 282.409091 33.2307692 290.136364 44.3076923 294 59.0769231 294 84.9230769 290.136364 92.3076923 278.545455 96 139.454545 96 127.863636 92.3076923 124 84.9230769 124 59.0769231"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FAFAFA",
    cx: 211,
    cy: 35.5,
    rx: 10,
    ry: 9.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveysEmpty);
export default __webpack_public_path__ + "static/media/surveys-empty.62fc9267297f4d7369aa3c49d9c6786a.svg";
export { ForwardRef as ReactComponent };